import CommonService from "./common.service";

const buyerDashboardService = {
  getDashboard: ({ dateFrom, dateTo, module } = {}) => {
    const params = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (module) params.module = module;
    return CommonService.get("/buyer/dashboard", params);
  },
  getTabNotificationCounts: () =>
    CommonService.get("/buyer/dashboard/tab-notifications", {}, { silent: true }),
};

export default buyerDashboardService;
